/* ============================================================
   VELISA - script del tema (porting di sito/bozza-velisa.html)
   Un solo file per tutte le pagine: ogni pezzo parte solo se trova
   i suoi elementi. Nessuna libreria. Le classi sono tutte v-*.
   1. utilità e dati del configuratore
   2. menu laterale + velo
   3. entrata allo scroll, scorrimenti continui (clienti, recensioni)
   4. carrello (pannello di Horizon, contenuto nostro da /cart.js)
   5. scheda prodotto: galleria, configuratore, anteprima SVG, gemme
   ============================================================ */
(() => {
'use strict';

/* ---------- 1. utilità ---------- */
const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const NS = 'http://www.w3.org/2000/svg';
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const wide = () => matchMedia('(min-width: 990px)').matches;   // sopra: il pannello di Horizon non è modale
const fmt = cents => (cents / 100).toFixed(2).replace('.', ',') + ' €';   // 6900 -> "69,00 €"
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
const CFG = window.VELISA || {};

function mix(hex, t){
  const n = parseInt(hex.slice(1), 16);
  const ch = s => { const v = (n >> s) & 255; const m = t > 0 ? v + (255 - v) * t : v * (1 + t); return Math.round(m).toString(16).padStart(2, '0'); };
  return '#' + ch(16) + ch(8) + ch(0);
}

const MONTHS = [
  { n:1,  mese:'Gennaio',   pietra:'Granato rosso',   c:'#9B1B30', g:'m' },
  { n:2,  mese:'Febbraio',  pietra:'Ametista viola',  c:'#8E5BB5', g:'f' },
  { n:3,  mese:'Marzo',     pietra:'Acquamarina',     c:'#6FB3E0', g:'f' },
  { n:4,  mese:'Aprile',    pietra:'Cristallo',       c:'#EDEDED', g:'m' },
  { n:5,  mese:'Maggio',    pietra:'Smeraldo',        c:'#1F8A4C', g:'m' },
  { n:6,  mese:'Giugno',    pietra:'Alessandrite',    c:'#7B2C8F', g:'f' },
  { n:7,  mese:'Luglio',    pietra:'Rubino',          c:'#E0526E', g:'m' },
  { n:8,  mese:'Agosto',    pietra:'Peridoto',        c:'#9BBE3A', g:'m' },
  { n:9,  mese:'Settembre', pietra:'Zaffiro',         c:'#1F3F99', g:'m' },
  { n:10, mese:'Ottobre',   pietra:'Tormalina rosa',  c:'#F19BC4', g:'f' },
  { n:11, mese:'Novembre',  pietra:'Citrino',         c:'#F2D16B', g:'m' },
  { n:12, mese:'Dicembre',  pietra:'Topazio blu',     c:'#2C8FD6', g:'m' },
];
const ZODIAC = [
  { id:'ariete',     nome:'Ariete',     date:'21 mar – 19 apr', s:'♈' },
  { id:'toro',       nome:'Toro',       date:'20 apr – 20 mag', s:'♉' },
  { id:'gemelli',    nome:'Gemelli',    date:'21 mag – 20 giu', s:'♊' },
  { id:'cancro',     nome:'Cancro',     date:'21 giu – 22 lug', s:'♋' },
  { id:'leone',      nome:'Leone',      date:'23 lug – 22 ago', s:'♌' },
  { id:'vergine',    nome:'Vergine',    date:'23 ago – 22 set', s:'♍' },
  { id:'bilancia',   nome:'Bilancia',   date:'23 set – 22 ott', s:'♎' },
  { id:'scorpione',  nome:'Scorpione',  date:'23 ott – 21 nov', s:'♏' },
  { id:'sagittario', nome:'Sagittario', date:'22 nov – 21 dic', s:'♐' },
  { id:'capricorno', nome:'Capricorno', date:'22 dic – 19 gen', s:'♑' },
  { id:'acquario',   nome:'Acquario',   date:'20 gen – 18 feb', s:'♒' },
  { id:'pesci',      nome:'Pesci',      date:'19 feb – 20 mar', s:'♓' },
];
/* Cinque cuori smaltati (24 settembre 2026: aggiunti fucsia, nero e bianco,
   dalla foto dei ciondoli del fornitore). Il bordo segue il metallo scelto. */
const HEARTS = [
  { id:'red',     label:'❤️ Cuore rosso',  short:'Cuore rosso',  c:'#D7263D' },
  { id:'pink',    label:'🩷 Cuore rosa',   short:'Cuore rosa',   c:'#F4A7B9' },
  { id:'fuchsia', label:'💖 Cuore fucsia', short:'Cuore fucsia', c:'#E2378F' },
  { id:'black',   label:'🖤 Cuore nero',   short:'Cuore nero',   c:'#1E1E1E' },
  { id:'white',   label:'🤍 Cuore bianco', short:'Cuore bianco', c:'#F6F3EE' },
];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const METALS = {
  gold:   { stops:['#E6C77A', '#C9A24D', '#A8822E'], dark:'#8A6A22', name:'Oro 18K' },
  /* il nome deve essere identico al valore "Colore" delle varianti su Shopify:
     e' cosi che si trova la variante vera da mettere nel carrello */
  rose:   { stops:['#F1C9B6', '#D9A18A', '#B97C67'], dark:'#8E5A49', name:'Oro rosa' },
  silver: { stops:['#EEF0F3', '#C8CCD2', '#979DA6'], dark:'#7C838C', name:'Argento' },
};
const typeOf = v => v ? v.split(':')[0] : '';

/* valore salvato nella riga d'ordine: "A", "Luglio · Rubino", "Cuore rosso", "Leone" */
function propertyLabel(v){
  const [type, id] = v.split(':');
  if (type === 'heart')  return HEARTS.find(h => h.id === id).short;
  if (type === 'stone')  { const m = MONTHS.find(m => m.n === +id); return m.mese + ' · ' + m.pietra; }
  if (type === 'zodiac') return ZODIAC.find(z => z.id === id).nome;
  return id;
}

/* ---------- 2. menu laterale + velo ---------- */
const overlay = $('[data-v-overlay]');
const menu = $('#v-menu');
const FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,summary,[tabindex]:not([tabindex="-1"])';
let menuTrigger = null;
function openMenu(trigger){
  if (!menu) return;
  menuTrigger = trigger || document.activeElement;
  menu.classList.add('v-is-open'); menu.setAttribute('aria-hidden', 'false');
  overlay && overlay.classList.add('v-is-open');
  document.body.classList.add('v-locked');
  $$('[data-v-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  setTimeout(() => { const f = $(FOCUSABLE, menu); if (f) f.focus(); }, reduced ? 0 : 320);
}
function closeMenu(){
  if (!menu || !menu.classList.contains('v-is-open')) return;
  menu.classList.remove('v-is-open'); menu.setAttribute('aria-hidden', 'true');
  overlay && overlay.classList.remove('v-is-open');
  document.body.classList.remove('v-locked');
  $$('[data-v-menu-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  if (menuTrigger && menuTrigger.focus) menuTrigger.focus();
}
$$('[data-v-menu-open]').forEach(b => b.addEventListener('click', e => openMenu(e.currentTarget)));
$$('[data-v-menu-close]').forEach(b => b.addEventListener('click', closeMenu));
document.addEventListener('keydown', e => {
  if (!menu || !menu.classList.contains('v-is-open')) return;
  if (e.key === 'Escape') { closeMenu(); return; }
  if (e.key === 'Tab') {
    const f = $$(FOCUSABLE, menu).filter(el => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/* ---------- 3. entrata allo scroll + scorrimenti continui ---------- */
const revealIO = new IntersectionObserver(entries => {
  entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('v-in'); revealIO.unobserve(en.target); } });
}, { threshold:.12, rootMargin:'0px 0px -40px 0px' });
$$('[data-reveal]').forEach(el => revealIO.observe(el));
$$('[data-reveal]').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) { el.classList.add('v-in'); revealIO.unobserve(el); } });
$$('.v-months').forEach(el => revealIO.observe(el));   // le gemme entrano a cascata

const avviaCarosello = t => {
  if (t.dataset.avviato) return;          // due avvii = due animazioni sullo stesso pezzo
  const first = $('.v-ticker__group', t);
  if (!first) return;
  t.dataset.avviato = '1';
  // velocità in pixel al secondo: resta uguale anche se il numero di schede cambia
  const speed = +t.dataset.speed || 0;
  const loop = +t.dataset.loop || 60;
  let groupW = 0, pos = 0, prev = 0, last = 0, idleAt = -1e9, hover = false, drag = null, running = false, inView = false;
  const measure = () => { groupW = first.offsetWidth; };
  const set = x => { t.scrollLeft = x; prev = t.scrollLeft; };
  const touch = () => { idleAt = performance.now(); running = false; };
  measure();
  new ResizeObserver(measure).observe(first);
  t.addEventListener('scroll', () => {
    const x = t.scrollLeft;
    if (groupW > 0) { if (x >= groupW) set(x - groupW); else if (x <= 0 && x < prev) set(x + groupW - 1); }
    if (!running) touch();
    prev = t.scrollLeft;
  }, { passive:true });
  t.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hover = true; });
  t.addEventListener('pointerleave', () => { hover = false; idleAt = performance.now(); });
  t.addEventListener('wheel', touch, { passive:true });
  t.addEventListener('touchstart', touch, { passive:true });
  t.addEventListener('pointerdown', e => {
    touch();
    if (e.pointerType !== 'mouse') return;
    drag = { x:e.clientX, left:t.scrollLeft };
    t.setPointerCapture(e.pointerId);
    t.classList.add('v-is-dragging');
  });
  t.addEventListener('pointermove', e => { if (!drag) return; t.scrollLeft = drag.left - (e.clientX - drag.x); touch(); });
  const endDrag = () => { if (!drag) return; drag = null; t.classList.remove('v-is-dragging'); touch(); };
  t.addEventListener('pointerup', endDrag);
  t.addEventListener('pointercancel', endDrag);
  new IntersectionObserver(([en]) => { inView = en.isIntersecting; }).observe(t);
  if (reduced) return;
  const step = now => {
    const dt = Math.min(64, now - last); last = now;
    const canRun = inView && !hover && !drag && now - idleAt > 3000 && groupW > 0;
    if (canRun) {
      if (!running) { running = true; pos = t.scrollLeft; }
      pos += (speed > 0 ? speed : groupW / loop) * dt / 1000;
      if (pos >= groupW) pos -= groupW;
      set(pos);
    } else running = false;
    requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};
$$('.v-ticker').forEach(avviaCarosello);

/* video con data-src: il file si scarica solo quando il video entra nello schermo */
const videoIO = new IntersectionObserver(entries => {
  entries.forEach(en => {
    if (!en.isIntersecting) return;
    const v = en.target; videoIO.unobserve(v);
    v.src = v.dataset.src; v.removeAttribute('data-src');
    const p = v.play(); if (p) p.catch(() => {});
  });
}, { rootMargin:'200px' });
$$('video[data-src]').forEach(v => videoIO.observe(v));

/* toast: piccolo avviso in basso (solo dove c'è) */
let toastId = null;
function toast(text){
  const el = $('[data-v-toast]');
  if (!el) return;
  el.textContent = text;
  el.classList.add('v-is-visible');
  clearTimeout(toastId);
  toastId = setTimeout(() => el.classList.remove('v-is-visible'), 2400);
}

/* ---------- 4. carrello ---------- */
const cartEl = $('[data-v-cart]');
const drawerEl = $('theme-drawer#cart-drawer');
let cart = null;
try { cart = JSON.parse(($('[data-v-cart-json]') || {}).textContent || 'null'); } catch (e) { cart = null; }
let secondMode = false;   // "sto componendo la seconda collana"
/* prezzo mostrato nella scheda: quello della variante scelta (metallo + numero di ciondoli) */
const EXTRA_OFF = (CFG.necklace && CFG.necklace.extraOff) || 1500;   // ogni collana dopo la prima costa questo in meno
let curPrice = CFG.necklace ? CFG.necklace.price : 0;
let curCompare = CFG.necklace ? CFG.necklace.compare : 0;
const GIFT_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"/><path d="M3 13h18M12 9v12"/><path d="M12 9c-2.5-4-6.5-3-6-1s3.5 1 6 1zm0 0c2.5-4 6.5-3 6-1s-3.5 1-6 1z"/></svg>';

const isGift = it => CFG.gift && it.product_id === CFG.gift.id;
const isNecklace = it => CFG.necklace && it.product_id === CFG.necklace.id;
const isExtra = it => CFG.extra && it.product_id === CFG.extra.id;
const necklaceUnits = c => (c ? c.items : []).reduce((n, it) => n + (isNecklace(it) ? it.quantity : 0), 0);
const shownUnits = c => (c ? c.items : []).reduce((n, it) => n + (isGift(it) ? 0 : it.quantity), 0);

async function api(url, body){
  const r = await fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) { const err = new Error(d.description || d.message || 'Errore del carrello'); err.data = d; throw err; }
  return d;
}
async function loadCart(){
  const r = await fetch(CFG.routes.cart, { headers:{ Accept:'application/json' } });
  cart = await r.json();
  // la confezione inclusa è una sola: se ce n'è di più (carrelli vecchi, righe spezzate) si riporta a 1
  const gifts = cart.items.filter(isGift);
  if (gifts.length && gifts.reduce((n, g) => n + g.quantity, 0) > 1) {
    await api(CFG.routes.change, { id: gifts[0].key, quantity: 1 });
    for (const g of gifts.slice(1)) await api(CFG.routes.change, { id: g.key, quantity: 0 });
    const r2 = await fetch(CFG.routes.cart, { headers:{ Accept:'application/json' } });
    cart = await r2.json();
  }
  return cart;
}

/* pallino in testata: conta le collane (la confezione regalo no), con rimbalzo */
function updateBadge(bounce){
  const n = shownUnits(cart);
  $$('[data-v-badge]').forEach(b => {
    $('[data-v-badge-n]', b).textContent = n;
    b.classList.toggle('v-is-empty', n === 0);
    if (bounce) { b.classList.remove('v-bounce'); void b.offsetWidth; b.classList.add('v-bounce'); }
  });
  $$('[data-v-cart-n]').forEach(el => { el.textContent = n; });
}

/* conto alla rovescia (cosmetico) da 10:00: parte al primo "aggiungi", resta tra una pagina e l'altra */
let timerId = null;
const timerEl = $('[data-v-timer]');
const timerEnd = () => +sessionStorage.getItem('v-timer-end') || 0;
function tick(){
  if (!timerEl) return;
  const left = Math.max(0, timerEnd() - Date.now());
  const m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
  timerEl.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  if (left <= 0) { clearInterval(timerId); timerId = null; }
}
function startTimer(force){
  if (!timerEl) return;
  if (force || !timerEnd() || timerEnd() < Date.now()) sessionStorage.setItem('v-timer-end', Date.now() + 10 * 60 * 1000);
  tick();
  if (!timerId) timerId = setInterval(tick, 1000);
}
function stopTimer(){ clearInterval(timerId); timerId = null; sessionStorage.removeItem('v-timer-end'); if (timerEl) timerEl.textContent = '10:00'; }

function necklaceMeta(it){
  const opt = (it.options_with_values || []).reduce((o, x) => (o[x.name] = x.value, o), {});
  const props = it.properties || {};
  const scelte = Object.keys(props).filter(k => /^Scelta \d$/.test(k)).sort().map(k => props[k]).filter(Boolean);
  const bits = [];
  if (opt.Colore) bits.push('Colore: ' + esc(opt.Colore));
  if (opt.Ciondoli) bits.push('Ciondoli: ' + esc(opt.Ciondoli));
  if (scelte.length) bits.push('Personalizzazione: ' + esc(scelte.join(' · ')));
  return bits.join('<br>');
}
function thumbFor(it){
  const opt = (it.options_with_values || []).find(x => x.name === 'Colore');
  const t = CFG.necklace && CFG.necklace.thumbs;
  const own = it.featured_image && it.featured_image.url;
  if (t) {
    if (opt && /argento/i.test(opt.value)) return t.silver || own;
    if (opt && /rosa/i.test(opt.value)) return t.rose || t.gold || own;   // manca ancora una foto in oro rosa
    return t.gold || own;
  }
  return own;
}

function renderCart(){
  if (!cartEl || !cart) return;
  const rows = $('[data-v-cart-rows]', cartEl), totals = $('[data-v-totals]', cartEl), checkout = $('[data-v-checkout]', cartEl);
  const real = cart.items.filter(it => !isGift(it));
  const empty = real.length === 0;
  cartEl.classList.toggle('v-is-empty', empty);
  if (empty) {
    rows.innerHTML = '<p class="v-cart-empty">Il tuo carrello è vuoto.</p>';
    totals.innerHTML = '';
    checkout.textContent = 'Vai alla cassa • ' + fmt(0);
    stopTimer();
    syncSecondMode();
    return;
  }
  let html = '';
  /* la confezione regalo inclusa: prezzo 0, prezzo pieno 2,00 € (compare_at della variante),
     quantità bloccata a 1. Il "+" aggiunge invece una "Confezione regalo aggiuntiva" (2,00 €), riga a sé. */
  const gifts = cart.items.filter(isGift);
  if (gifts.length) {
    const g0 = gifts[0];
    const qty = gifts.reduce((n, g) => n + g.quantity, 0);
    const compare = (CFG.gift.compare || 0) * 1;
    html += `
    <div class="v-cart-row" data-key="${esc(g0.key)}">
      <div class="v-cart-row__thumb">${g0.featured_image && g0.featured_image.url ? `<img src="${esc(g0.featured_image.url)}" width="72" height="72" alt="" loading="lazy">` : GIFT_ICON}</div>
      <div>
        <div class="v-cart-row__title"><span>${esc(g0.product_title)}</span>${compare > g0.final_price ? '<span class="v-tag">Regalo</span>' : ''}</div>
        <div class="v-cart-row__meta">Inclusa in ogni ordine</div>
        <div class="v-cart-row__bottom">
          <div class="v-qty" aria-label="Quantità confezione regalo">
            <button type="button" aria-label="Meno" disabled>−</button><span>${Math.min(qty, 1)}</span><button type="button" data-action="extra-plus" aria-label="Aggiungi una confezione a ${fmt(CFG.extra ? CFG.extra.price : 200)}"${CFG.extra ? '' : ' disabled'}>+</button>
          </div>
          <div class="v-cart-row__price">${compare > g0.final_price ? `<s>${fmt(compare)}</s>` : ''}<b>${fmt(g0.final_price)}</b></div>
        </div>
      </div>
    </div>`;
  }
  real.forEach(it => {
    const vv = isNecklace(it) ? CFG.necklace.variants.find(x => x.id === it.variant_id) : null;
    const compare = isNecklace(it) ? ((vv && vv.compare) || CFG.necklace.compare) * it.quantity : 0;
    const listed = it.original_line_price;
    const thumb = isNecklace(it) ? thumbFor(it) : (it.featured_image && it.featured_image.url);
    html += `
    <div class="v-cart-row" data-key="${esc(it.key)}">
      <div class="v-cart-row__thumb">${thumb ? `<img src="${esc(thumb)}" width="72" height="72" alt="" loading="lazy">` : GIFT_ICON}</div>
      <div>
        <div class="v-cart-row__title"><span>${esc(it.product_title)}</span><button class="v-remove" type="button" data-action="qty" data-key="${esc(it.key)}" data-q="0">Rimuovi</button></div>
        <div class="v-cart-row__meta">${isNecklace(it) ? necklaceMeta(it) : (isExtra(it) ? 'Confezione aggiuntiva' : esc(it.variant_title || ''))}</div>
        <div class="v-cart-row__bottom">
          <div class="v-qty" aria-label="Quantità">
            <button type="button" data-action="qty" data-key="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Meno">−</button><span>${it.quantity}</span><button type="button" data-action="qty" data-key="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Più">+</button>
          </div>
          <div class="v-cart-row__price${compare > listed ? ' v-cart-row__price--save' : ''}">${compare > listed ? `<span class="v-save">Risparmi ${fmt(compare - listed)}</span><s>${fmt(compare)}</s>` : ''}<b>${fmt(listed)}</b></div>
        </div>
      </div>
    </div>`;
  });
  const nCollane = necklaceUnits(cart);
  if (nCollane >= 1 && nCollane <= 9 && CFG.necklace) {
    const altra = nCollane === 1 ? 'una seconda collana' : "un'altra collana";
    html += `
    <div class="v-cart-upsell">
      <div><b>Aggiungi ${altra} da ${fmt(CFG.necklace.price - EXTRA_OFF)}</b><p>${EXTRA_OFF % 100 ? fmt(EXTRA_OFF) : (EXTRA_OFF / 100) + ' €'} in meno su ogni collana in più. Uguale o diversa: scegli tu i ciondoli.</p></div>
      <button type="button" data-action="second">Componila ora</button>
    </div>`;
  }
  rows.innerHTML = html;
  syncSecondMode();

  /* totali: listino, poi ogni sconto (automatico o codice) raggruppato per nome:
     "Seconda collana −20 €" è ripartito da Shopify sulle due righe (10 + 10), qui torna una riga sola */
  const subtotal = cart.items.reduce((n, it) => n + it.original_line_price, 0);
  const disc = new Map();
  cart.items.forEach(it => {
    (it.line_level_discount_allocations || []).forEach(a => {
      const k = a.discount_application.title;
      const d = disc.get(k) || { amount:0, type:a.discount_application.type, title:k };
      d.amount += a.amount; disc.set(k, d);
    });
  });
  (cart.cart_level_discount_applications || []).forEach(a => {
    // forma di /cart.js: { amount, discount_application: { title, type, total_allocated_amount } }
    const app = a.discount_application || a;
    const k = app.title;
    const d = disc.get(k) || { amount:0, type:app.type, title:k };
    // lo stesso sconto sta anche sulle righe (ripartito): si prende il valore più alto, non la somma
    d.amount = Math.max(d.amount, (typeof a.amount === 'number' ? a.amount : app.total_allocated_amount) || 0); disc.set(k, d);
  });
  let t = `<div><span>Subtotale</span><span>${fmt(subtotal)}</span></div>`;
  disc.forEach(d => {
    if (d.amount <= 0) return;
    const isCode = d.type === 'discount_code';
    t += `<div class="v-discount"><span>${isCode ? 'Sconto ' + esc(d.title) : esc(d.title)}${isCode ? ` <button type="button" data-action="code-remove" data-code="${esc(d.title)}" aria-label="Togli il codice sconto">✕</button>` : ''}</span><span>−${fmt(d.amount)}</span></div>`;
  });
  t += `<div><span>Spedizione</span><span>Gratuita</span></div>
        <div class="v-total"><span>Totale</span><span>${fmt(cart.total_price)}</span></div>`;
  totals.innerHTML = t;
  checkout.textContent = 'Vai alla cassa • ' + fmt(cart.total_price);
  if (timerEnd() > Date.now()) startTimer();
}

function busy(on){ if (cartEl) cartEl.classList.toggle('v-cart-busy', on); }
function setCodeMsg(text, kind){
  const el = $('[data-v-code-msg]', cartEl);
  if (!el) return;
  el.textContent = text;
  el.className = 'v-code-msg' + (kind ? ' v-is-' + kind : '');
}

/* apertura e chiusura del pannello di Horizon */
function drawer(){ return document.getElementById('cart-drawer'); }
/* rilegge /cart.js e ridisegna pannello e pallino: ad ogni apertura, al ritorno sulla
   pagina, e su richiesta (document.dispatchEvent(new Event('velisa:cart:refresh'))) */
let refreshing = null;
function refreshCart(){
  if (!CFG.routes) return Promise.resolve();
  if (refreshing) return refreshing;
  refreshing = loadCart().then(() => { renderCart(); updateBadge(false); }).catch(() => {}).finally(() => { refreshing = null; });
  return refreshing;
}
document.addEventListener('velisa:cart:refresh', () => { refreshCart(); });
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshCart(); });
function openCart(){
  const d = drawer(); if (!d) return;
  renderCart();
  refreshCart();
  if (typeof d.open === 'function') d.open();
  else customElements.whenDefined('theme-drawer').then(() => d.open());
}
function closeCart(){ const d = drawer(); if (d && typeof d.close === 'function') d.close(); }
$$('[data-v-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
/* arrivo da /cart (anche tornando indietro dalla cassa): carrello aperto subito */
if (location.hash === '#carrello') {
  history.replaceState(null, '', location.pathname + location.search);
  openCart();
}
$$('[data-v-cart-close]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); closeCart(); }));
/* sopra i 990 px il dialog non è modale: velo e blocco dello scorrimento li mettiamo noi */
function syncCartOpen(){
  const open = drawerEl && drawerEl.hasAttribute('open');
  document.body.classList.toggle('v-cart-open', !!open);
  if (overlay) overlay.classList.toggle('v-is-open', !!(open && wide()) || (menu && menu.classList.contains('v-is-open')));
  $$('[data-v-cart-open]').forEach(b => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
}
document.addEventListener('theme-drawer:open', e => { syncCartOpen(); if (e.target === drawerEl) refreshCart(); });
document.addEventListener('theme-drawer:close', syncCartOpen);
if (overlay) overlay.addEventListener('click', () => { closeMenu(); closeCart(); });
syncCartOpen();

/* click dentro il carrello: quantità, rimozione, codice, seconda collana */
if (cartEl) cartEl.addEventListener('click', async e => {
  const btn = e.target.closest('[data-action]');
  if (!btn) return;
  const a = btn.dataset.action;
  if (a === 'second') {
    closeCart();
    setSecondMode(true);
    const cfg = $('#v-config');
    if (cfg) cfg.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block:'start' });
    else if (CFG.necklace) location.href = CFG.necklace.url + '#v-config-extra';
    return;
  }
  try {
    busy(true);
    if (a === 'qty') {
      await api(CFG.routes.change, { id: btn.dataset.key, quantity: +btn.dataset.q });
      await loadCart();
      // senza collane le confezioni (inclusa e aggiuntive) non hanno senso: via anche loro
      if (necklaceUnits(cart) === 0 && cart.items.some(it => isGift(it) || isExtra(it))) {
        for (const g of cart.items.filter(it => isGift(it) || isExtra(it))) await api(CFG.routes.change, { id: g.key, quantity: 0 });
        await loadCart();
      }
    }
    if (a === 'extra-plus' && CFG.extra) {
      await api(CFG.routes.add, { items: [{ id: CFG.extra.variant, quantity: 1 }] });
      await loadCart();
    }
    if (a === 'code-remove') {
      await api(CFG.routes.update, { discount: '' });
      await loadCart();
      setCodeMsg('', '');
      const inp = $('[data-v-code-input]', cartEl); if (inp) inp.value = '';
    }
  } catch (err) { setCodeMsg(err.message, 'err'); }
  finally { busy(false); renderCart(); updateBadge(false); }
});

/* codice sconto: si passa a Shopify, che dice se vale */
const codeForm = $('[data-v-code-form]');
if (codeForm) codeForm.addEventListener('submit', async e => {
  e.preventDefault();
  const inp = $('[data-v-code-input]', codeForm);
  const v = (inp.value || '').trim().toUpperCase();
  if (!v) { setCodeMsg('Inserisci un codice.', 'err'); return; }
  try {
    busy(true);
    const d = await api(CFG.routes.update, { discount: v });
    const ok = (d.discount_codes || []).some(c => c.code.toUpperCase() === v && c.applicable);
    if (!ok) {
      await api(CFG.routes.update, { discount: (d.discount_codes || []).filter(c => c.applicable && c.code.toUpperCase() !== v).map(c => c.code).join(',') });
      await loadCart();
      setCodeMsg('Codice non valido.', 'err');
    } else {
      await loadCart();
      setCodeMsg('Codice applicato: ' + v + '.', 'ok');
      inp.value = '';
    }
  } catch (err) { setCodeMsg('Codice non valido.', 'err'); }
  finally { busy(false); renderCart(); }
});

/* aggiunge una collana (con le sue proprietà) e, se manca, la confezione regalo */
async function addNecklace(variantId, properties){
  const items = [{ id: variantId, quantity: 1, properties }];
  const hasGift = cart && cart.items.some(isGift);
  if (CFG.gift && !hasGift) items.push({ id: CFG.gift.variant, quantity: 1 });
  await api(CFG.routes.add, { items });
  await loadCart();
  startTimer(!timerEnd() || timerEnd() < Date.now());
  renderCart();
  updateBadge(true);
}

if (cart) { renderCart(); updateBadge(false); }
/* tornando indietro col tasto del browser la pagina può arrivare dalla cache: si ricarica il carrello */
addEventListener('pageshow', () => { refreshCart(); });

/* ---------- 5. scheda prodotto ---------- */
const config = $('#v-config');
function showPrice(){
  const band = $('[data-v-second-band]'); if (band) band.hidden = !secondMode;
  if (!CFG.necklace || !$('[data-v-price-value]')) return;
  const P = curPrice, C = curCompare, S = P - EXTRA_OFF, on = secondMode;
  const ora = on ? S : P, prima = on ? P : C;
  $('[data-v-price-value]').textContent = fmt(ora);
  $('[data-v-price-old]').textContent = fmt(prima);
  const badge = $('[data-v-price-badge]');
  if (badge) { badge.textContent = '−' + Math.round((1 - ora / prima) * 100) + '%'; badge.hidden = !(prima > ora); }
  const nel = necklaceUnits(cart);
  const bandTxt = band && band.querySelector('span');
  if (bandTxt) bandTxt.textContent = 'Stai componendo ' + (nel >= 2 ? "un'altra collana" : 'la seconda collana') + ' · ' + fmt(S);
  const sp = $('[data-v-sticky-price]'), so = $('[data-v-sticky-old]');
  if (sp) sp.textContent = fmt(ora);
  if (so) so.textContent = fmt(prima);
}
function setSecondMode(on){ secondMode = on; showPrice(); }
const secondCancel = $('[data-v-second-cancel]');
if (secondCancel) secondCancel.addEventListener('click', () => setSecondMode(false));
/* la modalita' "collana in piu'" vale solo se nel carrello ci sono da 1 a 9 collane:
   se il cliente toglie la collana dal carrello, la scheda torna a 69 */
function syncSecondMode(){
  if (!secondMode) return;
  const n = necklaceUnits(cart);
  setSecondMode(n >= 1 && n <= 9);
}
if (location.hash === '#v-config-extra' && config) {
  history.replaceState(null, '', location.pathname + location.search);
  refreshCart().then(() => {
    const n = necklaceUnits(cart);
    if (n >= 1 && n <= 9) setSecondMode(true);
    config.scrollIntoView({ block: 'start' });
  });
}

if (config && CFG.necklace) {
  const state = { color:'gold', count:4, slots:['', '', '', ''] };
  const varianteDi = (color, count) => CFG.necklace.variants.find(x => x.color === METALS[color].name && String(x.count) === String(count));
  /* prezzo, barrato e "+2 €" sui bottoni seguono metallo e numero di ciondoli */
  function updatePrice(){
    const v = varianteDi(state.color, state.count);
    if (v) { curPrice = v.price; curCompare = v.compare || v.price; }
    const base = varianteDi(state.color, 1);
    $$('[data-v-plus]').forEach(el => {
      const vv = varianteDi(state.color, +el.dataset.vPlus);
      const d = vv && base ? vv.price - base.price : 0;
      el.textContent = d > 0 ? '+' + (d % 100 ? fmt(d) : (d / 100) + ' €') : '';
      el.hidden = !(d > 0);
    });
    showPrice();
  }

  /* tendine */
  const SELECTS = $$('.v-choice select', config);
  const WRAPS   = $$('.v-choice', config);
  const optionsHTML = () =>
    '<option value="">Scegli un ciondolo</option>' +
    '<optgroup label="Cuore" data-type="heart">' + HEARTS.map(h => `<option value="heart:${h.id}">${h.label}</option>`).join('') + '</optgroup>' +
    '<optgroup label="Pietra del mese" data-type="stone">' + MONTHS.map(m => `<option value="stone:${m.n}">${m.mese} · ${m.pietra}</option>`).join('') + '</optgroup>' +
    '<optgroup label="Segno zodiacale" data-type="zodiac">' + ZODIAC.map(z => `<option value="zodiac:${z.id}">${z.nome} (${z.date})</option>`).join('') + '</optgroup>' +
    '<optgroup label="Iniziale" data-type="initial">' + LETTERS.map(l => `<option value="initial:${l}">${l}</option>`).join('') + '</optgroup>';
  SELECTS.forEach(s => { s.innerHTML = optionsHTML(); });

  /* Scelta libera dei ciondoli dal 27/09/2026: anche piu' iniziali, piu' pietre o piu' cuori.
     Le voci restano sempre attive (anche su iOS, dove conta la singola voce). */
  function applyRule(){
    SELECTS.forEach(sel => { $$('optgroup, option', sel).forEach(o => { o.disabled = false; }); });
  }
  const isComplete = () => state.slots.slice(0, state.count).every(Boolean);
  const statusEl = $('[data-v-status]');
  function updateStatus(){
    const ok = isComplete();
    statusEl.textContent = ok ? 'Perfetta ✨ Prendila prima che finisca' : 'Completa le tue scelte 👆';
    statusEl.classList.toggle('v-is-ok', ok);
  }
  function refresh(){ applyRule(); renderPreview(); updateStatus(); }

  let avvisoTimer = null;
  function avvisa(testo){
    clearTimeout(avvisoTimer);
    statusEl.textContent = testo;
    statusEl.classList.remove('v-is-ok');
    avvisoTimer = setTimeout(updateStatus, 2600);
  }
  SELECTS.forEach((sel, i) => sel.addEventListener('change', () => {
    state.slots[i] = sel.value;
    WRAPS[i].classList.remove('v-is-invalid');
    refresh();
  }));
  $('[data-v-reset]').addEventListener('click', () => {
    state.slots = ['', '', '', ''];
    SELECTS.forEach(s => { s.value = ''; });
    WRAPS.forEach(w => w.classList.remove('v-is-invalid'));
    refresh();
  });

  /* numero di ciondoli: le tendine in più spariscono, le scelte restano */
  function setCount(n){
    const prev = state.count;
    state.count = n;
    $('[data-v-count-name]').textContent = n;
    WRAPS.forEach((w, i) => w.classList.toggle('v-is-hidden', i >= n));
    updatePrice();
    refresh();
  }
  $$('input[name="count"]').forEach(r => r.addEventListener('change', () => setCount(+r.value)));

  /* colore: cambia il gradiente dell'anteprima */
  const svg = $('#v-preview-svg');
  function setColor(c){
    state.color = c;
    const m = METALS[c];
    $$('#metal stop', svg).forEach((s, i) => s.setAttribute('stop-color', m.stops[i]));
    svg.style.setProperty('--metal-dark', m.dark);
    /* stessa cosa per i ciondoli della fascia "Il tuo segno" */
    $$('#metal-z stop').forEach((s, i) => s.setAttribute('stop-color', m.stops[i]));
    const zrow = $('#v-zodiac-row');
    if (zrow) zrow.style.setProperty('--metal-dark', m.dark);
    $('[data-v-color-name]').textContent = m.name;
    updatePrice();
  }
  $$('input[name="color"]').forEach(r => r.addEventListener('change', () => setColor(r.value)));

  /* anteprima SVG */
  const slotsLayer = $('#v-slots', svg);
  const P = [[20, -12], [110, 150], [290, 150], [380, -12]];
  const T = { 1:[.5], 2:[.36, .64], 3:[.27, .5, .73], 4:[.2, .4, .6, .8] };
  function bez(t){
    const mt = 1 - t, a = mt*mt*mt, b = 3*mt*mt*t, c = 3*mt*t*t, d = t*t*t;
    return [a*P[0][0] + b*P[1][0] + c*P[2][0] + d*P[3][0], a*P[0][1] + b*P[1][1] + c*P[2][1] + d*P[3][1]];
  }
  (() => {   // maglie della catena
    const pts = []; for (let i = 0; i <= 700; i++) pts.push(bez(i / 700));
    let acc = 0, next = 0, k = 0, out = '';
    for (let i = 1; i < pts.length; i++) {
      const [x0, y0] = pts[i - 1], [x1, y1] = pts[i];
      acc += Math.hypot(x1 - x0, y1 - y0);
      if (acc < next) continue;
      const ang = (Math.atan2(y1 - y0, x1 - x0) * 180 / Math.PI).toFixed(1), x = x1.toFixed(1), y = y1.toFixed(1);
      out += k % 2 === 0
        ? `<ellipse cx="${x}" cy="${y}" rx="4.2" ry="2.3" transform="rotate(${ang} ${x} ${y})" fill="none" stroke="url(#metal)" stroke-width="1.5"/>`
        : `<ellipse cx="${x}" cy="${y}" rx="2.4" ry="1.5" transform="rotate(${ang} ${x} ${y})" fill="url(#metal)" stroke="var(--metal-dark)" stroke-width=".3"/>`;
      next += 6.5; k++;
    }
    $('#v-chain-links', svg).innerHTML = out;
  })();
  (() => {   // gradienti di pietre e cuori
    const defs = $('#v-stone-defs', svg);
    const add = (id, c) => defs.insertAdjacentHTML('beforeend',
      `<radialGradient id="${id}" cx=".35" cy=".3" r=".85"><stop offset="0" stop-color="${mix(c, .55)}"/><stop offset=".5" stop-color="${c}"/><stop offset="1" stop-color="${mix(c, -.4)}"/></radialGradient>`);
    MONTHS.forEach(m => add('stone-' + m.n, m.c));
    HEARTS.forEach(h => add('heart-' + h.id, h.c));
  })();
  const BAIL = '<circle cx="0" cy="4" r="3.5" fill="none" stroke="url(#metal)" stroke-width="2"/><line x1="0" y1="7.5" x2="0" y2="12" stroke="url(#metal)" stroke-width="1.6"/>';
  const SPARK = 'M0-5 L1.2-1.2 5 0 1.2 1.2 0 5 -1.2 1.2 -5 0 -1.2-1.2Z';
  function charmMarkup(v, i){
    if (!v) return `<g class="v-fade">${BAIL}<circle cx="0" cy="26" r="13" fill="none" stroke="#CFC8BB" stroke-width="1.5" stroke-dasharray="4 4"/></g>`;
    const [type, id] = v.split(':');
    let body = '';
    if (type === 'initial') {
      body = `<text class="v-ch-initial v-ch-initial--shadow" x="1" y="45" text-anchor="middle">${id}</text>
              <text class="v-ch-initial v-ch-initial--face" x="0" y="44" text-anchor="middle">${id}</text>
              <text class="v-ch-initial v-ch-initial--edge" x="-.5" y="43.4" text-anchor="middle">${id}</text>`;
    } else if (type === 'stone') {
      body = `<circle cx="0" cy="27" r="15.5" fill="url(#metal)" stroke="var(--metal-dark)" stroke-width=".6"/>
              <circle cx="0" cy="27" r="12.5" fill="url(#stone-${id})"/>
              <ellipse cx="-4.5" cy="21.5" rx="4" ry="2.4" fill="#fff" opacity=".6" transform="rotate(-30 -4.5 21.5)"/>
              <path class="v-sparkle" d="${SPARK}" fill="#fff" transform="translate(7 18)" style="animation-delay:${(i * .6).toFixed(1)}s"/>`;
    } else if (type === 'heart') {
      body = `<path d="M0 41 C-14 31 -17 21 -12.5 15.5 C-8.5 10.5 -1.5 11.5 0 18 C1.5 11.5 8.5 10.5 12.5 15.5 C17 21 14 31 0 41 Z" fill="url(#heart-${id})" stroke="url(#metal)" stroke-width="2" stroke-linejoin="round"/>
              <ellipse cx="-5.5" cy="18.5" rx="3" ry="1.8" fill="#fff" opacity=".55" transform="rotate(-35 -5.5 18.5)"/>`;
    } else if (type === 'zodiac') {
      const z = ZODIAC.find(z => z.id === id);
      const foro = 'zp-' + id;
      body = `<defs><mask id="${foro}">
                <circle cx="0" cy="27" r="15" fill="#fff"/>
                <text class="v-ch-cut" x="0" y="33.5" text-anchor="middle">${z.s}</text>
              </mask></defs>
              <circle cx="0" cy="27" r="15" fill="url(#metal)" stroke="var(--metal-dark)" stroke-width=".8" mask="url(#${foro})"/>`;
    }
    return `<g class="v-swing" style="animation-delay:${(-i * .9).toFixed(1)}s"><g class="v-pop">${BAIL}${body}</g></g>`;
  }
  const rendered = [];
  function renderPreview(){
    const ts = T[state.count];
    while (rendered.length > state.count) rendered.pop().el.remove();
    ts.forEach((t, i) => {
      const [x, y] = bez(t);
      let r = rendered[i];
      if (!r) {
        const g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'v-slot');
        g.style.transform = `translate(${x}px, ${y}px)`;
        slotsLayer.appendChild(g);
        r = rendered[i] = { el:g, value:null };
      }
      r.el.style.transform = `translate(${x}px, ${y}px)`;
      const v = state.slots[i] || '';
      if (r.value !== v) { r.el.innerHTML = charmMarkup(v, i); r.value = v; }
      r.el.classList.toggle('v-can-drag', !!v);
    });
  }

  /* trascina i ciondoli per cambiare ordine */
  let drag = null;
  const toSvg = e => { const p = new DOMPoint(e.clientX, e.clientY).matrixTransform(svg.getScreenCTM().inverse()); return [p.x, p.y]; };
  const nearestSlot = x => { let best = 0, bd = Infinity; T[state.count].forEach((t, j) => { const d = Math.abs(bez(t)[0] - x); if (d < bd) { bd = d; best = j; } }); return best; };
  const moveItem = (arr, a, b) => { const it = arr.splice(a, 1)[0]; arr.splice(b, 0, it); };
  slotsLayer.addEventListener('pointerdown', e => {
    const g = e.target.closest('.v-slot'); if (!g) return;
    const i = rendered.findIndex(r => r.el === g);
    if (i < 0 || !rendered[i].value) return;
    e.preventDefault();
    const [px, py] = toSvg(e), [sx, sy] = bez(T[state.count][i]);
    drag = { i, target:i, dx:px - sx, dy:py - sy, pid:e.pointerId };
    g.classList.add('v-is-dragging');
    slotsLayer.appendChild(g);
    svg.setPointerCapture(e.pointerId);
  });
  svg.addEventListener('pointermove', e => {
    if (!drag || e.pointerId !== drag.pid) return;
    const [px, py] = toSvg(e);
    rendered[drag.i].el.style.transform = `translate(${px - drag.dx}px, ${py - drag.dy}px)`;
    const t = nearestSlot(px - drag.dx);
    if (t === drag.target) return;
    drag.target = t;
    const order = rendered.map((_, j) => j).filter(j => j !== drag.i);
    order.splice(t, 0, drag.i);
    order.forEach((slotIdx, pos) => {
      if (slotIdx === drag.i) return;
      const [x, y] = bez(T[state.count][pos]);
      rendered[slotIdx].el.style.transform = `translate(${x}px, ${y}px)`;
    });
  });
  function endDrag(e){
    if (!drag || e.pointerId !== drag.pid) return;
    rendered[drag.i].el.classList.remove('v-is-dragging');
    if (drag.target !== drag.i) {
      const active = state.slots.slice(0, state.count);
      moveItem(active, drag.i, drag.target);
      state.slots = active.concat(state.slots.slice(state.count));
      moveItem(rendered, drag.i, drag.target);
      SELECTS.forEach((s, k) => { if (k < state.count) s.value = state.slots[k]; });
    }
    drag = null;
    refresh();
  }
  svg.addEventListener('pointerup', endDrag);
  svg.addEventListener('pointercancel', endDrag);

  /* prezzo con count-up */
  function countUp(el, to, dur = 900){
    if (reduced) { el.textContent = fmt(to); return; }
    const t0 = performance.now();
    const step = now => {
      const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      if (secondMode) return;           // nel frattempo e' partita la collana in piu': vale il suo prezzo
      el.textContent = fmt(to * e);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  const priceNow = $('[data-v-price-now]');
  const priceIO = new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { if (!secondMode) countUp($('[data-v-price-value]'), curPrice); priceIO.disconnect(); } });
  }, { threshold:.5 });
  priceIO.observe(priceNow);

  /* aggiungi al carrello: variante vera + proprietà "Scelta N" */
  const addBtn = $('[data-v-add]'), stickyAdd = $('[data-v-sticky-add]');
  function variantId(){
    const v = varianteDi(state.color, state.count);
    return v ? v.id : null;
  }
  let adding = false;
  async function tryAdd(fromBar){
    if (adding) return;
    if (!isComplete()) {
      statusEl.classList.remove('v-shake'); void statusEl.offsetWidth; statusEl.classList.add('v-shake');
      const idx = state.slots.findIndex((v, i) => i < state.count && !v);
      WRAPS[idx].classList.add('v-is-invalid');
      if (fromBar) WRAPS[idx].scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block:'center' });
      SELECTS[idx].focus({ preventScroll:true });
      return;
    }
    const id = variantId();
    if (!id) { statusEl.textContent = 'Variante non disponibile.'; return; }
    const properties = {};
    state.slots.slice(0, state.count).forEach((v, i) => { properties['Scelta ' + (i + 1)] = propertyLabel(v); });
    const label = addBtn.textContent;
    adding = true; addBtn.disabled = true; addBtn.textContent = 'Un attimo…';
    try {
      await addNecklace(id, properties);
      if (secondMode) setSecondMode(false);
      openCart();
    } catch (err) {
      statusEl.textContent = err.message || 'Non siamo riusciti ad aggiungere la collana. Riprova.';
      statusEl.classList.remove('v-is-ok');
    } finally { adding = false; addBtn.disabled = false; addBtn.textContent = label; }
  }
  addBtn.addEventListener('click', () => tryAdd(false));
  if (stickyAdd) stickyAdd.addEventListener('click', () => tryAdd(true));

  /* barra fissa sul telefono */
  const stickyBar = $('[data-v-sticky-bar]');
  if (stickyBar) new IntersectionObserver(([en]) => {
    const show = !en.isIntersecting && en.boundingClientRect.top < 0;
    stickyBar.classList.toggle('v-is-visible', show);
    document.body.classList.toggle('v-has-bar', show && innerWidth < 1024);
  }, { threshold:0 }).observe(addBtn);

  /* riquadro acquisto sticky su desktop: se è più alto della finestra, si aggancia dal basso */
  const buybox = $('#v-buybox');
  function updateSticky(){
    if (innerWidth < 1024) { buybox.style.top = ''; return; }
    const header = $('.v-header');
    const headerH = (header ? header.offsetHeight : 64) + 16;
    const h = buybox.offsetHeight;
    buybox.style.top = (h + headerH > innerHeight ? innerHeight - h - 16 : headerH) + 'px';
  }
  new ResizeObserver(updateSticky).observe(buybox);
  addEventListener('resize', updateSticky);

  /* galleria: puntini, contatore, lightbox */
  const track = $('#v-gallery-track'), dots = $('#v-gallery-dots'), counter = $('#v-gallery-counter');
  const items = $$('.v-gallery__item', track);
  // posizione della foto dentro il carosello, misurata sul posto: offsetLeft
  // non serve, perché la pista non è l'elemento di riferimento del layout
  const posizione = li => track.scrollLeft + li.getBoundingClientRect().left - track.getBoundingClientRect().left;
  const galleryBtns = $$('.v-gallery__btn');
  const media = galleryBtns;
  galleryBtns.forEach((b, i) => {
    const d = document.createElement('button');
    d.type = 'button'; d.setAttribute('aria-label', 'Vai alla foto ' + (i + 1));
    d.addEventListener('click', () => track.scrollTo({ left: posizione(items[i]), behavior: reduced ? 'auto' : 'smooth' }));
    dots.appendChild(d);
  });
  function setCurrent(i){
    counter.textContent = (i + 1) + '/' + media.length;
    $$('button', dots).forEach((d, j) => { if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
  }
  setCurrent(0);
  let raf = 0;
  track.addEventListener('scroll', () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      // l'indice si ricava dalla posizione delle foto, non da una divisione:
      // con larghezze frazionarie l'arrotondamento saltava una foto nel contatore
      const x = track.scrollLeft + track.clientWidth / 2;
      let i = 0, best = Infinity;
      items.forEach((li, k) => {
        const c = posizione(li) + li.offsetWidth / 2;
        const d = Math.abs(c - x);
        if (d < best) { best = d; i = k; }
      });
      setCurrent(i);
    });
  }, { passive:true });
  /* Galleria non cliccabile: foto e video si guardano e si scorrono, non si
     aprono. L'ingranditore è stato tolto il 23 settembre 2026 su richiesta di
     Nicola, perché il video apriva i comandi di sistema ed era brutto. */

  /* il tuo mese, il tuo colore: click = pietra nella prima tendina libera */
  const monthsGrid = $('#v-months-grid');
  if (monthsGrid) {
    monthsGrid.innerHTML = MONTHS.map((m, i) =>
      `<li><button class="v-gem-card" type="button" data-month="${m.n}" style="--i:${i}" aria-label="${m.mese}, ${m.pietra}, aggiungi alla collana"><span class="v-gem-bezel" aria-hidden="true"><span class="v-gem" style="--c:${m.c}"></span></span><b>${m.mese}</b><small>${m.pietra}</small></button></li>`
    ).join('');
    monthsGrid.addEventListener('click', e => {
      const b = e.target.closest('.v-gem-card'); if (!b) return;
      const m = MONTHS.find(x => x.n === +b.dataset.month);
      const v = 'stone:' + m.n;
      const active = state.slots.slice(0, state.count);
      let idx = active.findIndex(s => !s);
      if (idx < 0) idx = active.findIndex(s => typeOf(s) === 'stone');
      if (idx < 0) idx = state.count - 1;
      state.slots[idx] = v; SELECTS[idx].value = v;
      WRAPS[idx].classList.remove('v-is-invalid');
      refresh();
      toast(`${m.pietra} ${m.g === 'f' ? 'aggiunta' : 'aggiunto'} alla tua collana ✨`);
      config.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block:'start' });
      WRAPS[idx].classList.add('v-is-flash');
      setTimeout(() => WRAPS[idx].classList.remove('v-is-flash'), 1600);
    });
  }

  /* "Il tuo segno": i dodici ciondoli veri, in fila, a scorrimento continuo.
     Il simbolo è forato nel dischetto, come il ciondolo vero. */
  const zodiacRow = $('#v-zodiac-row');
  if (zodiacRow) {
    const zodiacRow2 = $('#v-zodiac-row-2');
    const scheda = (z, suff) => {
      const foro = 'zb-' + z.id + suff;
      const nascosta = suff === 'b' ? ' tabindex="-1"' : '';
      return `<li><button class="v-zodiac-card" type="button"${nascosta} data-zodiac="${z.id}" aria-label="${z.nome}, ${z.date}, aggiungi alla collana">` +
        `<svg class="v-zodiac-charm" viewBox="-20 0 40 46" aria-hidden="true">` +
          `<defs><mask id="${foro}">` +
            `<circle cx="0" cy="27" r="15" fill="#fff"/>` +
            `<text class="v-ch-cut" x="0" y="33.5" text-anchor="middle">${z.s}</text>` +
          `</mask></defs>` +
          `<circle cx="0" cy="4" r="3.5" fill="none" stroke="url(#metal-z)" stroke-width="2"/>` +
          `<line x1="0" y1="7.5" x2="0" y2="12" stroke="url(#metal-z)" stroke-width="1.6"/>` +
          `<circle cx="0" cy="27" r="15" fill="url(#metal-z)" stroke="var(--metal-dark)" stroke-width=".8" mask="url(#${foro})"/>` +
        `</svg>` +
        `<b>${z.nome}</b><small>${z.date}</small>` +
      `</button></li>`;
    };
    zodiacRow.innerHTML = ZODIAC.map(z => scheda(z, 'a')).join('');
    if (zodiacRow2) zodiacRow2.innerHTML = ZODIAC.map(z => scheda(z, 'b')).join('');

    const aggiungi = e => {
      const b = e.target.closest('.v-zodiac-card'); if (!b) return;
      const z = ZODIAC.find(x => x.id === b.dataset.zodiac);
      const v = 'zodiac:' + z.id;
      const active = state.slots.slice(0, state.count);
      let idx = active.findIndex(s => !s);
      if (idx < 0) idx = active.findIndex(s => typeOf(s) === 'zodiac');
      if (idx < 0) idx = state.count - 1;
      state.slots[idx] = v; SELECTS[idx].value = v;
      WRAPS[idx].classList.remove('v-is-invalid');
      refresh();
      toast(`${z.nome} aggiunto alla tua collana ✨`);
      config.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block:'start' });
      WRAPS[idx].classList.add('v-is-flash');
      setTimeout(() => WRAPS[idx].classList.remove('v-is-flash'), 1600);
    };
    const giostra = $('.v-zodiac__ticker');
    if (giostra) { giostra.addEventListener('click', aggiungi); avviaCarosello(giostra); }
    else zodiacRow.addEventListener('click', aggiungi);
  }

  /* avvio: se l'indirizzo porta una variante (inserzioni di catalogo, ?variant=...),
     la scheda si apre su quel metallo e quel numero di ciondoli, con il suo prezzo */
  const daUrl = CFG.necklace.variants.find(x => String(x.id) === new URLSearchParams(location.search).get('variant'));
  const coloreIniziale = (daUrl && Object.keys(METALS).find(k => METALS[k].name === daUrl.color)) || 'gold';
  const ciondoliIniziali = (daUrl && +daUrl.count) || 4;
  const radioColore = $(`input[name="color"][value="${coloreIniziale}"]`); if (radioColore) radioColore.checked = true;
  const radioCiondoli = $(`input[name="count"][value="${ciondoliIniziali}"]`); if (radioCiondoli) radioCiondoli.checked = true;
  setColor(coloreIniziale);
  if (ciondoliIniziali !== 4) setCount(ciondoliIniziali);
  refresh();
  updateSticky();
  if (location.hash === '#v-config') setTimeout(() => config.scrollIntoView({ block:'start' }), 50);
}

/* home: le sei gemme in anteprima sono link alla scheda */
const homeGrid = $('[data-v-months-home]');
if (homeGrid) {
  const pick = [1, 2, 5, 7, 11, 12].map(n => MONTHS.find(m => m.n === n));
  const url = homeGrid.dataset.url || '#';
  homeGrid.innerHTML = pick.map((m, i) =>
    `<li><a class="v-gem-card" href="${esc(url)}#v-months" style="--i:${i}"><span class="v-gem-bezel" aria-hidden="true"><span class="v-gem" style="--c:${m.c}"></span></span><b>${m.mese}</b><small>${m.pietra}</small></a></li>`
  ).join('');
}
})();
